// Espelho de cabine-foto-gestao/src/constants/types/tipoTotem.js
// Tipo do totem — decide a Home inteira:
//  - PADRAO → config global (config/home), foto de cima + carrossel embaixo
//  - EVENTO → config exclusiva do totem (personalizaTotem/{totemUID}), foto
//             única em tela cheia com o botão ao centro, sem carrossel
// O campo é gravado no doc do totem e só ADMIN altera (pelo gestão).
// O MODELO (ver tiposDeTotem.js) não interfere na Home.
export const tipoTotem = {
  PADRAO: "PADRAO",
  EVENTO: "EVENTO",
};

// Valor legado: antes desta versão a Home exclusiva era marcada como "TOTINHO"
// no TIPO. Hoje "Totinho" é MODELO e o tipo equivalente é EVENTO. Totens já
// gravados como TOTINHO continuam carregando a Home própria.
export const TIPO_TOTEM_LEGADO_EVENTO = "TOTINHO";

// Totens antigos não possuem o campo — ausência = PADRAO.
export const ehEvento = (tipo) =>
  tipo === tipoTotem.EVENTO || tipo === TIPO_TOTEM_LEGADO_EVENTO;

// O doc do totem só chega no primeiro onSnapshot, alguns segundos depois de a
// Home montar. Sem lembrar o tipo, todo boot de um totem de evento mostraria a
// Home com carrossel e trocaria para a de foto única na frente do cliente.
const CHAVE_TIPO = "totemTipo";

export function lembrarTipoTotem(tipo) {
  try {
    localStorage.setItem(CHAVE_TIPO, tipo || tipoTotem.PADRAO);
  } catch (_) {
    // storage indisponível (quota/modo privado) — só perde a otimização
  }
}

export function tipoTotemLembrado() {
  try {
    return localStorage.getItem(CHAVE_TIPO);
  } catch (_) {
    return null;
  }
}

// Home de foto única (sem carrossel) ⇔ totem do tipo EVENTO, qualquer que seja
// o modelo. Enquanto o doc do totem não chegou (sem id), vale o tipo lembrado
// do boot anterior.
export function homeSemCarrossel(totem) {
  const tipo = totem && totem.id ? totem.tipoTotem : tipoTotemLembrado();
  return ehEvento(tipo);
}
